import events from "@/bl-events"

let config

const isGuest = () => {
  if (!config) {
    return true
  }
  return config.guest
}

const isLoggedIn = () => {
  return !isGuest()
}

const isPremiumUser = () => {
  if (!config || config.guest) {
    return false
  }
  return config.segment === "premium"
}

events.on("setup:ready", (data) => {
  config = data
})

export default {
  isGuest,
  isLoggedIn,
  isPremiumUser
}
